import { render } from "./form-card.vue?vue&type=template&id=6590027f&scoped=true"
import script from "./form-card.vue?vue&type=script&lang=js"
export * from "./form-card.vue?vue&type=script&lang=js"

import "./form-card.vue?vue&type=style&index=0&id=6590027f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6590027f"],['__file',"src/layouts/auth-layout/components/form-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6590027f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6590027f', __exports__)) {
    api.reload('6590027f', __exports__)
  }
  
  module.hot.accept("./form-card.vue?vue&type=template&id=6590027f&scoped=true", () => {
    api.rerender('6590027f', render)
  })

}


export default __exports__